var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttendeesTileWaveform = function SvgAttendeesTileWaveform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 128,
    viewBox: "0 0 120 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1034 -11.4077C29.5501 12.0547 77.865 22.2153 64.0922 56.2428C50.3194 90.2703 11.6045 94.1129 24 136.048C36.3955 177.984 97.3107 177.774 126.141 139.289C146.588 111.997 154.481 67.9522 141.315 25.4562C129.853 -11.5332 77.4605 -45.4353 49.1034 -11.4077Z",
    fill: "url(#paint0_linear_2534_7987)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10078 128.03C-3.25378 100.909 18.5011 86.2841 44.5465 84.8019C90.8288 82.1677 71.1885 25.8605 120 36.1901C168.811 46.5197 174.584 133.414 130.834 169.264C87.0835 205.114 10.8237 188.574 1.10078 128.028V128.03Z",
    fill: "url(#paint1_linear_2534_7987)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M55.3293 153.466C37.2225 130.119 52.5952 113.056 72.3431 103.943C92.0909 94.8291 83.8887 66.8765 97.5616 61.4083C111.235 55.9402 127.004 62.3248 130.071 105.445C133.717 156.707 78.4205 183.241 55.3293 153.466Z",
    fill: "url(#paint2_linear_2534_7987)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9262 -14.549C7.76967 10.8436 29.0535 33.6609 48.1946 34.9256C67.3358 36.1902 70.6765 15.5284 99.5405 17.0491C128.405 18.5671 150.28 9.45354 145.114 -17.5877C139.948 -44.629 66.1198 -66.5042 26.9262 -14.549Z",
    fill: "#3568E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2534_7987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4277 62.8145C65.1326 62.8145 69.7573 58.1897 69.7573 52.4849C69.7573 46.78 65.1326 42.1553 59.4277 42.1553C53.7229 42.1553 49.0981 46.78 49.0981 52.4849C49.0981 58.1897 53.7229 62.8145 59.4277 62.8145Z",
    fill: "url(#paint3_linear_2534_7987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4277 62.8145C65.1326 62.8145 69.7573 58.1897 69.7573 52.4849C69.7573 46.78 65.1326 42.1553 59.4277 42.1553C53.7229 42.1553 49.0981 46.78 49.0981 52.4849C49.0981 58.1897 53.7229 62.8145 59.4277 62.8145Z",
    fill: "#2D5DD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2534_7987",
    x: 10.0981,
    y: 15.1553,
    width: 104.659,
    height: 104.659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2534_7987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2534_7987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2534_7987",
    x1: 81.3926,
    y1: 135.905,
    x2: 92.329,
    y2: 5.46265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3794"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2534_7987",
    x1: 14.7584,
    y1: 161.156,
    x2: 160.515,
    y2: 77.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13BAE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3794"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2534_7987",
    x1: 76.672,
    y1: 151.193,
    x2: 112.292,
    y2: 77.8205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3794"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2534_7987",
    x1: 62.597,
    y1: 59.7758,
    x2: 56.5196,
    y2: 45.8007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1545C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3794"
  })))));
};
export default SvgAttendeesTileWaveform;